// eslint-disable-next-line no-restricted-imports
import { useBaseAppContext } from "@acin.reactjs/acin-ui/baseApp";
import {
  AppBackendAPI,
  AppBackendProviderProps,
} from "../interfaces/BackendInterfaces";
import { AppParamsProps, Session } from "../interfaces/BaseAppInterfaces";

const useAppContext = () =>
  useBaseAppContext<
    AppParamsProps,
    Session,
    AppBackendAPI,
    AppBackendProviderProps
  >();

export default useAppContext;
